export function getGridColumnClass(index: number, columnType: 'primary' | 'secondary'): string {
	const position = (index % 2) + (columnType === 'primary' ? 1 : 4)
	switch (position) {
		case 1:
			return 'col-start-1'
		case 2:
			return 'col-start-2'
		case 4:
			return 'col-start-4'
		case 5:
			return 'col-start-5'
		default:
			return ''
	}
}

export function getGridRowClass(index: number): string {
	const row = Math.floor(index / 2) + 1
	switch (row) {
		case 1:
			return 'row-start-1'
		case 2:
			return 'row-start-2'
		case 3:
			return 'row-start-3'
		case 4:
			return 'row-start-4'
		case 5:
			return 'row-start-5'
		case 6:
			return 'row-start-6'
		case 7:
			return 'row-start-7'
		case 8:
			return 'row-start-8'
		case 9:
			return 'row-start-9'
		case 10:
			return 'row-start-10'
		default:
			return ''
	}
}
